module.exports = __webpack_public_path__ + "static/media/hat-winter.2fac0520.svg";